/* Venz Market header interactions: menu, account dropdown, animated search, product type filter, live cart summary. */
(function () {
  if (window.__vzLoaded) return;
  window.__vzLoaded = true;

  function T(k, d) { var t = window.vzT || {}; return (t[k] != null && t[k] !== '') ? t[k] : d; }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeader(root) {
    if (!root || root.__vzInit) return;
    root.__vzInit = true;

    // Keep the header on top while scrolling (works even if the theme blocks CSS sticky)
    var sec = root.closest('.shopify-section') || root.parentElement;
    if (sec && sec.parentNode) {
      var spacer = document.createElement('div');
      spacer.className = 'vz-sticky-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      sec.parentNode.insertBefore(spacer, sec);
      var update = function () {
        if (!document.body.contains(root)) return;
        var top = spacer.getBoundingClientRect().top;
        if (top < 0) {
          if (!root.classList.contains('vz-fixed')) {
            spacer.style.height = root.offsetHeight + 'px';
            root.classList.add('vz-fixed');
          }
        } else if (root.classList.contains('vz-fixed')) {
          root.classList.remove('vz-fixed');
          spacer.style.height = '0px';
        }
      };
      window.addEventListener('scroll', update, { passive: true });
      // Some layouts scroll an inner element instead of the window: listen to every scroll
      document.addEventListener('scroll', update, { passive: true, capture: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(update, { threshold: [0, 1] }).observe(spacer);
      }
      window.addEventListener('resize', function () {
        if (root.classList.contains('vz-fixed')) spacer.style.height = root.offsetHeight + 'px';
        update();
      });
      update();
    }

    // Menu
    var burger = root.querySelector('[data-vz-burger]');
    var menu = root.querySelector('[data-vz-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = menu.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Account dropdown
    var acct = root.querySelector('[data-vz-acct]');
    var acctBtn = root.querySelector('[data-vz-acct-btn]');
    if (acct && acctBtn) {
      acctBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = acct.classList.toggle('is-open');
        acctBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (menu && burger && !menu.contains(e.target) && !burger.contains(e.target)) {
        menu.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
      if (acct && acctBtn && !acct.contains(e.target)) {
        acct.classList.remove('is-open');
        acctBtn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (menu) menu.classList.remove('is-open');
      if (acct) acct.classList.remove('is-open');
    });

    // Search: product type filter + popular searches + typing placeholder
    var form = root.querySelector('[data-vz-search]');
    var q = root.querySelector('[data-vz-q]');
    var typeSel = root.querySelector('[data-vz-type]');
    if (form && q) {
      form.addEventListener('submit', function () {
        var t = typeSel ? typeSel.value : '';
        if (!t) return;
        var v = q.value.trim();
        q.value = 'product_type:"' + t.replace(/"/g, '') + '"' + (v ? ' ' + v : '');
        setTimeout(function () { q.value = v; }, 0);
      });

      var sg = root.querySelector('[data-vz-sg]');
      if (sg) {
        sg.addEventListener('mousedown', function (e) { e.preventDefault(); });
        sg.querySelectorAll('[data-vz-pop] button').forEach(function (b) {
          b.addEventListener('click', function () {
            q.value = b.textContent.trim();
            if (form.requestSubmit) form.requestSubmit(); else form.submit();
          });
        });
        initLiveSearch(form, q, typeSel, sg);
      }

      var base = q.getAttribute('placeholder') || 'Search products';
      var words = (q.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      if (words.length && !reduceMotion) {
        var wi = 0, ci = 0, del = false;
        var tick = function () {
          if (!document.body.contains(q)) return;
          if (document.activeElement === q || q.value) { setTimeout(tick, 500); return; }
          var w = words[wi];
          if (!del) {
            ci++; q.placeholder = T('search_for', 'Search for') + ' ' + w.slice(0, ci);
            if (ci === w.length) { del = true; setTimeout(tick, 1500); return; }
            setTimeout(tick, 75);
          } else {
            ci--; q.placeholder = T('search_for', 'Search for') + ' ' + w.slice(0, ci);
            if (ci === 0) { del = false; wi = (wi + 1) % words.length; setTimeout(tick, 350); return; }
            setTimeout(tick, 35);
          }
        };
        q.addEventListener('focus', function () { q.placeholder = base; });
        tick();
      }
    }
  }

  // Live search: shows matching products and collections while the shopper types
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function mark(text, term) {
    var safe = esc(text);
    var words = term.split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) {
      return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function initLiveSearch(form, q, typeSel, sg) {
    var box = sg.querySelector('[data-vz-res]');
    var pop = sg.querySelector('[data-vz-pop]');
    if (!box || !window.fetch) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 6;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var timer = null, ctrl = null, last = '', active = -1;

    function show(on) {
      box.hidden = !on;
      if (pop) pop.hidden = on;
      sg.classList.toggle('has-res', on);
      if (!on) { box.innerHTML = ''; active = -1; }
    }

    function allUrl(term) {
      var t = typeSel ? typeSel.value : '';
      var full = t ? 'product_type:"' + t.replace(/"/g, '') + '" ' + term : term;
      return rootUrl + 'search?type=product&q=' + encodeURIComponent(full);
    }

    function render(term, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var cols = res.collections || [];
      var t = typeSel ? typeSel.value : '';
      if (t) products = products.filter(function (p) { return p.type === t; });
      products = products.slice(0, limit);

      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var html = '';
      if (products.length) {
        html += '<p>' + esc(T('products', 'Products')) + '</p><ul class="vz-lr-list" role="listbox">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          var alt = (p.featured_image && p.featured_image.alt) || p.title;
          var price = Math.round(parseFloat(p.price) * 100);
          html += '<li><a class="vz-lr-item" role="option" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(sized(img, 120)) + '" alt="' + esc(alt) + '" width="56" height="56" loading="lazy">' : '<span class="vz-lr-ph" aria-hidden="true"></span>') +
            '<span class="vz-lr-txt"><span class="vz-lr-t">' + mark(p.title, term) + '</span>' +
            (p.vendor ? '<small>' + esc(p.vendor) + '</small>' : '') + '</span>' +
            (isNaN(price) ? '' : '<b>' + esc(money(price, cur)) + '</b>') +
            (p.available === false ? '<em>' + esc(T('sold_out', 'Sold out')) + '</em>' : '') +
            '</a></li>';
        });
        html += '</ul>';
      }
      if (cols.length) {
        html += '<p>' + esc(T('collections', 'Collections')) + '</p><div class="vz-lr-cols">';
        cols.slice(0, 3).forEach(function (c) {
          html += '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        });
        html += '</div>';
      }
      if (!products.length && !cols.length) {
        html += '<div class="vz-lr-none">' + esc(T('no_products', 'No products found for')) + ' &ldquo;' + esc(term) + '&rdquo;. ' + esc(T('try_another', 'Try another word, or')) + ' <a href="' + rootUrl + 'pages/contact">' + esc(T('ask_us', 'ask us')) + '</a> ' + esc(T('find_it', 'and we will find it for you.')) + '</div>';
      } else {
        html += '<a class="vz-lr-all" href="' + esc(allUrl(term)) + '">' + esc(T('see_all', 'See all results for')) + ' &ldquo;' + esc(term) + '&rdquo; &rarr;</a>';
      }
      box.innerHTML = html;
      active = -1;
      show(true);
    }

    function run() {
      var term = q.value.trim();
      if (term.length < 2) { last = ''; show(false); return; }
      var key = term + '|' + (typeSel ? typeSel.value : '');
      if (key === last) return;
      last = key;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var n = typeSel && typeSel.value ? 10 : limit;
      var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection&resources[limit]=' + n +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,vendor,product_type,tag,variants.title,variants.sku,variants.barcode';
      sg.classList.add('is-loading');
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (q.value.trim() === term) render(term, data); })
        .catch(function () {})
        .then(function () { sg.classList.remove('is-loading'); });
    }

    q.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 180);
    });
    if (typeSel) typeSel.addEventListener('change', function () { last = ''; run(); });
    q.addEventListener('focus', function () { if (q.value.trim().length >= 2) run(); });

    // Arrow keys move through the results, Enter opens the highlighted one
    q.addEventListener('keydown', function (e) {
      var items = box.hidden ? [] : box.querySelectorAll('a');
      if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = e.key === 'ArrowDown' ? (active + 1) % items.length : (active <= 0 ? items.length - 1 : active - 1);
        items.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1 && items[active]) {
        e.preventDefault();
        window.location.href = items[active].href;
      }
    });
  }

  // Live cart summary
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-vz-cart]').forEach(function (el) {
          var count = el.querySelector('[data-vz-count]');
          var total = el.querySelector('[data-vz-total]');
          var n = cart.item_count;
          var label = n + ' ' + (n === 1 ? T('item', 'item') : T('items', 'items'));
          var amount = money(cart.total_price, cart.currency);
          if (count) count.textContent = label;
          if (total) total.textContent = amount;
          el.setAttribute('aria-label', T('cart', 'Cart') + ': ' + label + ', ' + amount);
          el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
        });
      })
      .catch(function () {});
  }
  ['cart:update', 'cart:change', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, refreshCart);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  function initAll() {
    document.querySelectorAll('[data-vz-header]').forEach(initHeader);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
